import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
import { ROOT_URL } from '../../../../actions/root_url';
import axios from 'axios';

class ProductColorsModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
        };
    }

    componentDidMount() {
        this.getColorsData();
    }

    getColorsData = () => {
        if (this.props.Product_id) {
            this.setState({ editing: true });
            axios({
                method: 'get',
                headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
                url: `${ROOT_URL}v1/product/${this.props.Product_id}/color`,
            })
                .then(res => {
                    let data = [{ Name: '-', Color_id: 'clear' }, ...res.data, { Name: 'add / edit', Color_id: 'add' }];
                    this.setState({ data })
                }).catch((err) => {
                    this.setState({ editing: false });
                    alert(JSON.stringify(err));
                })
        }
    }

    addColor = () => {
        if (this.props.addColor) {
            this.props.addColor();
        }
    }

    clearColor = () => {
        if (this.props.clear) {
            this.props.clear();
        }
    }
    updateColor = (color) => {
        if (this.props.update) {
            this.props.update(color);
        }
    }

    render() {
        return (
            <Row>
                <Col sm={12}>
                    <div style={{
                        maxWidth: '100%',
                        marginTop: '5px',
                        overflow: 'scroll',
                        height: '230px',
                    }}>
                        {this.state.data.map((dat, index) => {
                            return <div key={index}
                                onClick={() => {
                                    if (dat.Color_id == 'add') {
                                        this.addColor();
                                    } else if (dat.Color_id == 'clear') {
                                        this.clearColor();
                                    } else {
                                        this.updateColor(dat.Name);
                                    }
                                }}
                                style={dat.Color_id == 'add' ? {...styles.item, color:'#999999'} : styles.item}>
                                {dat.Name}
                            </div>
                        })}
                    </div>
                </Col>
            </Row>
        );
    }
}

export default ProductColorsModal;

const styles = {
    item: {
        display: 'flex',
        width: '200px',
        height: '25px',
        alignItems: 'center',
        justifyContent: 'center',
        marginTop: '4px',
        borderStyle: 'solid',
        borderColor: '#999999',
        borderRadius: '10px'
    }
}



// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/product/ProductColorsModal.jsx